import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import BadgeResposta from '../shared/BadgeResposta';
import '../tipos/respostaSimNao.css';

const RespostaConformeNaoConforme = ({
  respostas,
  editable = false,
  valorSelecionado = null,
  onChange,
}) => {
  const resposta = respostas?.[0];
  const valor = valorSelecionado || resposta?.resposta || 'PENDENTE';
  const valorNormalizado = String(valor).toUpperCase();
  const conformeAtivo = valorNormalizado === 'CONFORME';
  const naoConformeAtivo = valorNormalizado === 'NÃO CONFORME';

  const handleChange = (_id, value) => {
    const normalizado = value.replace('_', ' ');
    onChange?.(normalizado);
  };

  return (
    <div className={`resp-bloco ${!resposta ? 'vazio' : ''}`}>
      <span className="resp-label">Resposta:</span>

      {editable ? (
        <div className="chk-resposta-botoes">
          <button
            type="button"
            className={`resposta-valor danger ${
              naoConformeAtivo ? 'is-active' : 'is-inactive'
            }`}
            onClick={() => handleChange(null, 'NÃO_CONFORME')}
            aria-pressed={naoConformeAtivo}
          >
            <FaTimesCircle className="resposta-icone" />
            <span className="resposta-texto">NÃO CONFORME</span>
          </button>
          <button
            type="button"
            className={`resposta-valor success ${
              conformeAtivo ? 'is-active' : 'is-inactive'
            }`}
            onClick={() => handleChange(null, 'CONFORME')}
            aria-pressed={conformeAtivo}
          >
            <FaCheckCircle className="resposta-icone" />
            <span className="resposta-texto">CONFORME</span>
          </button>
        </div>
      ) : (
        <BadgeResposta valor={valor} />
      )}

      {/* {resposta && (
        <div className="resp-datas">
          <small>última atualização: {resposta.dataUltimaResposta}</small>
        </div>
      )} */}
    </div>
  );
};

export default RespostaConformeNaoConforme;
